import React from 'react'

export const ClientAuthOutlet = React.lazy(() => import('./client-auth-outlet'))
export const UserAuthOutlet = React.lazy(() => import('./user-auth-outlet'))
